namespace Nobox {

    @Serenity.Decorators.registerFormatter()
    export class ActvFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            if (ctx.value == "" || ctx.value == null) {
                return `<span>Not Active</span>`;
            } else {
                if (ctx.value == 1) {
                    return `<span>Active</span>`;
                } else {
                    return `<span>Not Active</span>`;
                }
            }
        }
    }
}